export default __webpack_public_path__ + "static/media/globe-nav.21ed7d02.svg";